<template>
  <div id="app">
    <Header />
    <router-view />
    <el-backtop :bottom="100">
      <div class="backtop_box">
        <svg
          class="svg_style"
          viewBox="0 0 1024 1024"
          xmlns="http://www.w3.org/2000/svg"
          data-v-ba633cb8=""
        >
          <path
            fill="currentColor"
            d="m488.832 344.32-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872 319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0z"
          ></path>
        </svg>
      </div>
    </el-backtop>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss" >
@import "./assets/css/global.css";
@import "./assets/css/index.css";
.el-backtop {
  width: auto;
  height: auto;
  background: transparent;
  border-radius: 0;
}
.backtop_box {
  width: 50px;
  height: 50px;
  color: #b0b0b0;
  opacity: 0.7;
  border: 1px solid #ffffff;
  border-radius: 4px;
  background-color: #ffffff;
  transition: all 0.3s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 1;
    .svg_style {
      color: #000000;
      transition: all 1s;
    }
  }
  transition: all 1s;
}
.svg_style {
  width: 30px;
  height: 30px;
}
.img_top {
  width: 100%;
  height: auto;
  position: relative;
  img {
    width: 100%;
    height: auto;
  }
  .img_text_box {
    position: absolute;
    bottom: 60px;
    width: 100%;
    div {
      max-width: 1310px;
      padding: 0 300px;
      margin: 0 auto;
      text-align: center;
    }
    h4 {
      width: 100%;
      text-align: center;
      span {
        font-size: 52.0444px;
        font-weight: 400;
        padding: 4px 9px;
        background: rgba(0, 0, 0, 0.48);
      }
      line-height: 92.8126px;
      color: rgb(255, 255, 255);
    }
    p {
      font-weight: 400;
      font-size: 32px;
      line-height: 2em;
      color: rgb(255, 255, 255);
      background: rgba(0, 0, 0, 0.49);
      padding: 4px 9px;
      margin-top: -5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue